module.exports = __webpack_public_path__ + "img/amoun.1fe21923.jpg";